export default {
  strapi: {
    baseUrl: "https://strapi-dns.dental21.de",
    apiToken:
      "3df88b029486e946726bbd97455b7ce87029e7a898e85835876be11e011068219e0fa966e9e84517bb1cd2386b7e97b6755489f8dc9d29a9e75292c0aef86ec9ad5d7ace3ba7adb00ff36c08557cfaaa232975e4137ea14272df8464bdbbcaa0651daede7a58b7c29e2d66a2936896556bd54ef3ca6d2f13dbc735b7c1d3188b",
  },
};
